<template>
  <a-drawer :visible="visible" :width="850" @close="close">
    <img :src="url" alt />
  </a-drawer>
</template>

<script>
import Api from "@/api";
import baseModalVue from "./base-modal.vue";
export default {
  name: "resumePreview",
  extends: baseModalVue,
  data() {
    return {
      url: ""
    };
  },
  methods: {
    async show(attachment) {
      if (!attachment.preview_url && !attachment.id) {
        this.$message.info("暂无附件预览");
        return;
      }
      let url = attachment.preview_url;
      if (url) {
        this.open();
        this.url = url;
      } else {
        try {
          let { preview } = await Api.resume.generatePreview({
            attachment_id: attachment.id
          });
          if (preview && preview.file_url) {
            this.open();
            this.url = preview.file_url;
          } else {
            this.$message.info("暂无附件预览");
          }
        } catch (e) {}
      }
    }
  }
};
</script>
